module.exports = __webpack_public_path__ + "img/calculator-card-pictures-3.66ec9a48.jpg";